// Import and register all your controllers from the webpack entry point
import { application } from "./application"

// Import controllers
import HelloController from "./hello_controller"
import ImageCarouselController from "./image_carousel_controller"
import LogoScrollerController from "./logo_scroller_controller"
import ModalController from "./modal_controller"
import FlyoutMenuController from "./flyout_menu_controller"
import NavbarController from "./navbar_controller"
import FaqAccordionController from "./faq_accordion_controller"
import TeamCardController from "./team_card_controller"
import LightboxController from "./lightbox_controller"

// Register controllers with the application
application.register("hello", HelloController)
application.register("image-carousel", ImageCarouselController)
application.register("logo-scroller", LogoScrollerController)
application.register("modal", ModalController)
application.register("flyout-menu", FlyoutMenuController)
application.register("navbar", NavbarController)
application.register("faq-accordion", FaqAccordionController)
application.register("team-card", TeamCardController)
application.register("lightbox", LightboxController)

// Import and register any other controllers as needed
